'use strict';

var chunkVNK76C2V_js = require('../chunk-VNK76C2V.js');
require('../chunk-H6SGADBR.js');
require('../chunk-M632V57T.js');



Object.defineProperty(exports, "Label", {
	enumerable: true,
	get: function () { return chunkVNK76C2V_js.a; }
});
